import { extend } from 'vee-validate'
import { required, integer } from 'vee-validate/dist/rules'
import store from '../store'

extend('required', {
  ...required,
  message: 'The {_field_} field is required'
})

extend('integer', {
  ...integer,
  message: 'The {_field_} field must be an integer'
})

extend('positiveInteger', {
  ...integer,
  message: 'The {_field_} field must be a positive integer',
  validate (value) {
    return /^[1-9]\d*$/.test(value)
  }
})

export const IsJsonString = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

const VALID_HOSTNAME_PATTERN = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/
const VALID_URL_PATTERN = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/
const VALID_MAILTO_PATTERN = /^mailto:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\?[a-zA-Z0-9_.%+-]+=[a-zA-Z0-9_.%+-]*(&[a-zA-Z0-9_.%+-]+=[a-zA-Z0-9_.%+-]*)*)?$/

extend('hostname', {
  validate: (value) => VALID_HOSTNAME_PATTERN.test(value),
  message: 'Input must be a valid hostname, e.g., project.customer.org'
})

extend('url', {
  validate: (value) => VALID_URL_PATTERN.test(value),
  message: 'Input must be a valid URL, e.g., https://example.com'
})

extend('url_or_mailto', {
  validate: (value) => VALID_URL_PATTERN.test(value) || VALID_MAILTO_PATTERN.test(value),
  message: 'Input must be a valid URL (e.g., https://example.com) or mailto link (e.g., mailto:contact@example.com)'
})

extend('client', {
  validate: (value) => !(!value),
  message: 'Please select a client from the list'
})

extend('IsJsonString', IsJsonString)

extend('capabilityJson', {
  validate: (value) => IsJsonString(value),
  message: 'The capability definition is not valid JSON'
})

extend('json', {
  validate: (value) => IsJsonString(value),
  message: 'The {_field_} content is not valid JSON'
})

extend('verify_name', value => {
  const clients = store?.state?.clientsList
  const clientNames = Array.isArray(clients)
    ? clients
      .map(client => (typeof client === 'string' ? client : client?.name))
      .filter(Boolean)
      .map(name => name.toLowerCase())
    : []
  if (value && clientNames.indexOf(value.toLowerCase()) < 0) {
    return true
  }

  return `There is already a client with the name ${value}`
})
